import DOMPurify from "dompurify";

const HTMLSanitize = {
  install(Vue) {
    /**
     * Directiva para sanitizar HTML inyectado
     * @use `<component v-safe-html='variableConHtml' />`
     */
    Vue.directive("safe-html", {
      inserted: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      },
      update: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      }
    });

    /**
     * Directiva para sanitizar URLs inyectadas en
     * atributos href de links <a />
     * @use `<a v-safe-html='variableConURL'>Click aquí</a>`
     */
    Vue.directive("safe-href", {
      inserted: function (el, binding) {
        el.href = DOMPurify.sanitize(binding.value);
      },
      update: function (el, binding) {
        el.href = DOMPurify.sanitize(binding.value);
      }
    });
  }
};

export default HTMLSanitize;
